export * from './no-content.component';
